module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex--justify-center login"
  }, [_c('div', {
    staticClass: "login__content"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "login__form",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        _vm.handleSubmit($event)
      }
    }
  }, [(_vm.error) ? _c('div', {
    staticClass: "alert alert--danger",
    domProps: {
      "innerHTML": _vm._s(_vm.error)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.trainer) ? _c('div', {
    staticClass: "alert alert--danger"
  }, [_c('strong', [_vm._v("Failed to sign in!")]), _vm._v(" Only Trainer are allowed to access Live Run Console.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.username),
      expression: "user.username"
    }],
    class: {
      'form-control': true, 'is-danger': _vm.errors.has('username')
    },
    attrs: {
      "data-vv-rules": "required",
      "type": "text",
      "name": "username",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "username", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('username')),
      expression: "errors.has('username')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("Fill in the username")])]), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    class: {
      'form-control': true, 'is-danger': _vm.errors.has('password')
    },
    attrs: {
      "data-vv-rules": "required",
      "type": "password",
      "name": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("Fill in the password!")])]), _vm._v(" "), _c('div', {
    staticClass: "form__group form__group--inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberMe),
      expression: "rememberMe"
    }],
    attrs: {
      "type": "checkbox",
      "id": "rememberMe",
      "name": "rememberMe"
    },
    domProps: {
      "checked": Array.isArray(_vm.rememberMe) ? _vm._i(_vm.rememberMe, null) > -1 : (_vm.rememberMe)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rememberMe = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rememberMe = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberMe = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rememberMe"
    }
  }, [_vm._v("Remember me")])]), _vm._v(" "), _c('div', {
    staticClass: "form__group form__group--inline"
  }, [_c('router-link', {
    attrs: {
      "slot": "actions",
      "to": ""
    },
    slot: "actions"
  }, [_vm._v("Forget Password")])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn--primary btn--block",
    attrs: {
      "id": "sign-in"
    }
  }, [_vm._v("Sign In")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/logo.png"),
      "alt": "LiveRun"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("Username "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e480cc9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/Login.vue
// module id = 1666
// module chunks = 1